import React from 'react';
import { Outlet } from 'react-router-dom';
import styled from 'styled-components';
import Header from '../components/Header';
import Footer from '../components/Footer';

const Main = styled.main`
  min-height: 80vh;
  background: ${({ theme }) => theme.colors.white};
`;

const MainLayout = () => (
  <>
    <Header />
    <Main>
      <Outlet />
    </Main>
    <Footer />
  </>
);

export default MainLayout;
